import { HeaderState, HeaderActions } from './types';
import { SET_SHOW_SEARCH_BAR } from '../actions';

const initialState: HeaderState = {
  showSearchBar: false,
};

export default function reducer(
  state = initialState,
  action: HeaderActions
): HeaderState {
  if (!state) {
    return {
      ...initialState,
    };
  }

  switch (action.type) {
    case SET_SHOW_SEARCH_BAR: {
      return {
        ...state,
        showSearchBar: action.state,
      };
    }

    default:
  }

  return state;
}
